import Vue from "vue";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import Vue2Editor from "vue2-editor";

export { default as AppHeader } from "./app-header/app-header.vue";
export { default as AppMenu } from "./app-menu/app-menu";
export { default as AppPageNotFound } from "./page-not-found/page-not-found.vue";
export { default as AppUnauthorized } from "./unauthorized/unauthorized.vue";
export { default as ErrorBoundary } from "./error-boundary/error-boundary.vue";
export { default as ConfirmationDialog } from "./confirmation-dialog/confirmation-dialog.vue";

const requireComponent = require.context("./template/base", true, /\.vue$/);

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, "").replace(/\.\w+$/, ""))
  );

  Vue.component(
    `Base${componentName}`,
    componentConfig.default || componentConfig
  );
});

Vue.use(require("vue-chartist"));
Vue.use(Vue2Editor);
